// extracted by mini-css-extract-plugin
module.exports = {"card":"CompanyPlans_card__2-aTM","bg-right":"CompanyPlans_bg-right__27P6Q","bg-left":"CompanyPlans_bg-left__16smi"};